module.exports = __webpack_public_path__ + "static/media/registp04_zhCht.21523a28.png";